import { RentManagerUnit } from "../../data/models.interface"
import useQuery from "../useQuery"

export const useGetRentManagerUnitsQuery = () => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/rent-manager-units`
	return useQuery<void, RentManagerUnitsOutput>(url)
}
interface RentManagerUnitsOutput {
	rentManagerUnits: RentManagerUnit[]
}
